import NavigationMenuItem from './NavigationMenuItem'

export default NavigationMenuItem
